import {Tag} from 'antd'
import {Link} from 'react-router-dom'
import {versionStatusTag} from "../../utils/version/version_status_tag";

const VersionsColumns = (t, config) => {
    return [
        {
            title: (
                <span style={{textDecoration: 'underline'}}>
                    {t('common.id')}
                </span>
            ),
            dataIndex: 'version_id',
            sorter: {},
            render: (title, record) => (
                <Link to={config.routes.detail(record.version_id)}>{title}</Link>
            ),
            width: 200,
        },
        {
            title: t('pages.versions.listColumns.status'),
            dataIndex: 'status',
            render: (text, record) => {
                const statusTag = versionStatusTag(record.status) || {}

                return (
                    <Tag bordered={false} color={statusTag.color || 'default'}>
                        {statusTag.icon} {text}
                    </Tag>
                )
            }
        },
        {
            title: (
                <span style={{textDecoration: 'underline'}}>
                    {t('pages.versions.listColumns.versionNumber')}
                </span>
            ),
            dataIndex: 'version_number',
            render: (title, record) => (
                <Link to={config.routes.detail(record.version_id)}>{title}</Link>
            ),
        },
        {
            title: t('pages.versions.listColumns.devicesCount'),
            dataIndex: 'devices_count',
            render: value => value ?? '-',
        },
        {
            title: t('pages.versions.listColumns.companiesCount'),
            dataIndex: 'companies_count',
            render: value => value ?? '-',
        },
        {
            title: t('pages.versions.listColumns.file'),
            dataIndex: 'file',
        },
        {
            title: t('pages.versions.listColumns.storage'),
            dataIndex: 'is_save_remotely',
            render: value => (
                <Tag bordered color={value ? 'green' : 'red'}>
                    {value
                        ? t('pages.versions.detail.storage.remote')
                        : t('pages.versions.detail.storage.local')}
                </Tag>
            ),
        },
    ]
};

export const mapVersionDevice = item => ({
    key: item.id,
    market_name: item.market_name,
    device_serial_number: item.device_serial_number,
})

export const mapVersionCompany = item => ({
    key: item.id,
    public_name: item.public_name,
    inn: item.inn,
})

export const VersionDevicesColumns = t => [
    {
        title: t('pages.versions.detail.related.columns.marketName'),
        dataIndex: 'market_name',
        render: text => text || '-',
    },
    {
        title: t('pages.versions.detail.related.columns.serialNumber'),
        dataIndex: 'device_serial_number',
        render: text => (
            text ? <Link to={`/device/detail/${text}`}>{text}</Link> : '-'
        ),
    },
]

export const VersionCompaniesColumns = t => [
    {
        title: t('pages.versions.detail.related.columns.publicName'),
        dataIndex: 'public_name',
    },
    {
        title: t('pages.versions.detail.related.columns.inn'),
        dataIndex: 'inn',
        render: (text, record) => (
            <Link to={`/company/detail/${record.key}`}>{text || '-'}</Link>
        ),
    },
]

export default VersionsColumns;
